<template>
  <div v-if="dataModel[props.brandExperience].carousel" :class="`component__carousel--${props.iteration}`">
  <div class="carousel__bg">
    <div class="carousel__wrapper">
      <div class="carousel__pattern"></div>
      <div :class="carouselIteration">
        <div
          class="carousel__product"
          v-for="(item, key) in dataModel[props.brandExperience].carouselData[props.iteration]"
          :key="item"
        >
            <div>
              <img class="carousel__img--product opacity--0" :src="item.img" />
            </div>
            <div class="carousel__h1 px--20" v-html="item.title"></div>
            <button class="carousel__button" :data-id="key" data-action="csWidgetOpen">Buy now</button>
        </div>
      </div>
    </div>
    <div class="carousel__surface"></div>
  </div>
  </div>
</template>
<script setup>
import dataModel from '../js/model.js';
const props = defineProps({
  iteration: {
    type: String,
    default: "1",
  },
  brandExperience: {
    type: String,
    default: "1",
  }
});
var carouselIteration = "carousel--" + props.iteration;

$(document).ready(function () {
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .prepend(
      `<img class="carousel__previous--${props.iteration}" src="./arrow-circle.svg" width="40" style="position: absolute;top: calc(50% - 18px);z-index: 1150;left: 20px;transform:rotate(180deg)">`
    );
  $("." + carouselIteration)
    .closest(".carousel__wrapper")
    .append(
      `<img class="carousel__next--${props.iteration}" src="./arrow-circle.svg" width="40" style="position: absolute;top: calc(50% - 18px);z-index: 1150;right: 20px;">`
    );

  $("." + carouselIteration).slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: $(".carousel__previous--" + props.iteration),
    nextArrow: $(".carousel__next--" + props.iteration),
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.component__carousel--1 {
  .carousel__bg {
    background: rgb(0, 157, 222);
    background: linear-gradient(
      180deg,
      rgba(0, 157, 222, 1) 0%,
      rgba(114, 202, 244, 1) 50%
    );
    height: 850px;
    position: relative;

    @media screen and(max-width: 600px) {
      background-size: 320%;
      height: 700px;
    }
    @media screen and(max-width: 321px) {
      background-size: 350%;
    }
  }
  .carousel__wrapper {
    height: 100%;
    margin: auto;
    padding-top: 70px;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 100;
  }
  .carousel {
    width: 100%;
    margin: 0px auto;
  }
  .carousel__product {
    padding: 0px 20px;
    width: 100%;
    @media screen and(max-width: $width--xs) {
      padding-top: 30px;
    }
  }
  .wrapper .slick-dots li button:before {
    font-size: 20px;
    color: #000000;
  }
  .slick-arrow:before {
    color: #ffffff;
  }

  .carousel__h1 {
    color: #ffffff;
    font-size: 18px;
    font-weight: 900;
    letter-spacing: 2px;
    line-height: 22px;
    height: 90px;
    max-width: 700px;
    @media screen and(max-width: 1400px) {
      height: 110px;
    }

    @media screen and(max-width: $width--xs) {
      font-size: 15px;
      height: auto;
      margin-bottom: 20px;
      line-height: 19px;
      font-weight: 900;
    }
  }

  .carousel__button {
    background: #ffffff;
    border: 2px solid #ffffff;
    color: $color--green;
    font-weight: 900;
    padding: 15px;
    text-transform: uppercase;
    transition: ease all 0.2s;

    &:hover {
      color: #ffffff;
      cursor: pointer;
      background: none;
    }
  }
  .carousel__img--product {
    margin: auto;
    max-width: 300px;
    width: 100%;
    @media screen and(max-width: $width--xs) {
      max-width: 200px;
    }
  }
  .carousel__surface {
    background: rgb(90, 182, 7);
    background: linear-gradient(
      180deg,
      rgba(194, 206, 77, 1) 0%,
      rgba(126, 186, 76, 1) 100%
    );
    background-size: cover;
    bottom: 0px;
    height: 400px;
    position: absolute;
    width: 100%;
    @media screen and(max-width: $width--xs) {
      height: 350px;
    }
  }
  .carousel__pattern {
    background: url("/public/carousel-pattern.png");
    height: 100px;
    position: absolute;
    top: 350px;
    width: 100%;
    @media screen and(max-width: $width--xs) {
      top: 250px;
    }
  }
}

</style>